<template>
  <div v-if="hasValidCard" class="card-owned">
    <div
      class="text-sm border border-green-600 rounded-lg bg-green-50 px-3.5 py-3"
    >
      <template v-if="isUnlimitedCard">
        Je hebt een seizoenskaart voor deze locatie met
        <strong class="font-semibold">onbeperkt gebruik</strong>
      </template>
      <template v-else>
        Je hebt nog
        <strong class="font-semibold">{{ remaining }} strippen</strong>
        voor deze locatie
      </template>
    </div>
  </div>
  <div v-else-if="cards.length" class="card-offer">
    <div
      class="flex items-center gap-3 border border-green-600 rounded-lg px-3.5 py-3"
    >
      <p class="flex-1 m-0 text-sm">
        Voordeliger met een
        <strong class="font-semibold">strippenkaart</strong>
      </p>
      <div class="flex flex-col gap-2 items-end">
        <router-link
          v-for="card in cards"
          :key="card.id"
          :to="card.to"
          class="card-offer-link flex-shrink-0 h-9 leading-9 px-3.5 border border-green-600 rounded-xl text-sm font-medium text-green-700 hover:text-green-800 no-underline truncate max-w-10"
        >
          {{ card.label }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationCardNotice',
  props: {
    hasValidCard: { type: Boolean, default: false },
    isUnlimitedCard: { type: Boolean, default: false },
    remaining: { type: Number, default: 0 },
    creditcards: { type: Array, default: () => [] },
    // where the card purchase returns to after payment
    origin: { type: String, default: '' }
  },
  computed: {
    cards() {
      return this.creditcards.map((card) => ({
        id: card.id,
        label: this.creditcards.length > 1 ? card.name : 'Bekijk',
        to: {
          path: `/cards/${card.id}/purchase`,
          query: { origin: this.origin }
        }
      }))
    }
  }
}
</script>
